import { setSelectedQueryModal } from "redux/SingleDataset/actions";
import {
  getIsCardslistLoading,
  getNavigationClusterLoader,
} from "redux/SingleDataset/selectors";
import { useParams } from "react-router";
import { RefObject, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";

import styles from "./styles.module.scss";

export interface QueryModalProps {
  children: React.ReactNode;
  className?: string;
  keepOpenOnLoading?: boolean;
  modalRef?: RefObject<HTMLDivElement>;
}

export default function QueryModal({
  children,
  modalRef,
  className,
  keepOpenOnLoading = false,
}: QueryModalProps) {
  const dispatch = useDispatch();
  const { clusterId } = useParams();

  const isCardListLoading = useSelector((state) =>
    getIsCardslistLoading(state),
  );

  const isNavigationClusterLoading = useSelector((state) =>
    getNavigationClusterLoader(state),
  );

  const isLoading = clusterId ? isNavigationClusterLoading : isCardListLoading;

  useEffect(() => {
    if (keepOpenOnLoading && isLoading) return;

    const listener = (event: MouseEvent) => {
      if (!modalRef?.current?.contains(event.target as Node)) {
        dispatch(setSelectedQueryModal(null));
      }
    };

    document.addEventListener("mousedown", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
    };
    //eslint-disable-next-line
  }, [isLoading, keepOpenOnLoading, modalRef]);

  return (
    <div
      ref={modalRef}
      className={classNames(styles.queryModal, className, "queryModal")}
      data-testid="query-modal"
    >
      {children}
    </div>
  );
}
